import { TabProps } from "@mantine/core";

export enum TabValue {
  Autogroup = "autogroup",
  AddInvoice = "addInvoice",
}

export interface Tab extends TabProps {
  label: string;
}

export interface FilterValue {
  dpd?: number;
  customerId?: number;
  invoiceNumber?: string;
  invoiceDueDate?: string;
}
